export default "__VITE_ASSET__Dn5reM$3__"